import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import fuzhouMap from '../assets/data/fuzhou.json';
import businessData from '../assets/data/business.json';
import './MapChart.css';

// 将福州市各区县的数据整合
const fuzhouPerfData = businessData.unitPerformance;

// 福州市各区县的中心坐标（示例数据）
const fuzhouGeoCoordMap = {
  '鼓楼区': [119.30, 26.08],
  '台江区': [119.32, 26.04],
  '仓山区': [119.31, 26.00],
  '马尾区': [119.45, 25.98],
  '晋安区': [119.33, 26.12],
  '福清市': [119.3895, 25.7148],
  '长乐区': [119.5225, 25.9575],
  '闽侯县': [119.1333, 26.1500],
  '连江县': [119.5333, 26.2000],
  '罗源县': [119.5500, 26.4833],
  '平潭县': [119.7922, 25.5033],
  '永泰县': [118.9333, 25.8500],
  '闽清县': [118.8500, 26.3500]
};

const MapChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    // 注册地图数据
    echarts.registerMap('fuzhou', fuzhouMap);
    
    // 初始化图表实例
    const chartInstance = echarts.init(chartRef.current);

    // 配置项
    const option = {
      title: {
        text: '福州市地图可视化',
        left: 'center',
        textStyle: {
          color: '#ffffff',
          fontSize: 14,
          fontWeight: 'normal'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          if (params.data) {
            return `${params.name}: ${params.data.score || params.data.perf}`;
          }
          return params.name;
        }
      },
      geo: {
        map: 'fuzhou',
        roam: true,
        emphasis: {
          itemStyle: {
            areaColor: '#1e3a8a'
          }
        },
        itemStyle: {
          areaColor: '#0f172a',
          borderColor: '#3b82f6',
          borderWidth: 1
        }
      },
      series: [
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          data: fuzhouPerfData.map(item => ({
            name: item.name,
            value: [...fuzhouGeoCoordMap[item.name], item.perf],
            perf: item.perf
          })),
          symbolSize: function(val) {
            // 根据绩效值调整标记大小
            return Math.max(val[2] / 5, 10);
          },
          itemStyle: {
            color: function(params) {
              // 根据绩效值调整颜色
              const perf = params.data.perf;
              if (perf >= 90) return '#10B981'; // 绿色
              if (perf >= 80) return '#3B82F6'; // 蓝色
              if (perf >= 70) return '#F59E0B'; // 金色
              return '#EF4444'; // 红色
            },
            opacity: 0.8
          },
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          zlevel: 1
        }
      ]
    };

    // 设置配置项
    chartInstance.setOption(option);

    // 响应窗口大小变化
    const handleResize = () => {
      chartInstance.resize();
    };
    
    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize);
      chartInstance.dispose();
    };
  }, []);

  return <div ref={chartRef} className="map-chart"></div>;
};

export default MapChart;